import { forwardRef } from 'react';
import { cn } from '../utils/cn';

export interface AuroraCanvasProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Strength of the mesh. `subtle` is the right choice behind the densest
   * screens, where even a barely-there gradient competes with figures.
   */
  intensity?: 'subtle' | 'default';
}

/**
 * The fixed background for a glass screen. Renders at z-index 0 and is inert to
 * the pointer, so every screen must place its content in a stacking context
 * above it — `position: relative; z-index: 1` on the shell is enough.
 */
export const AuroraCanvas = forwardRef<HTMLDivElement, AuroraCanvasProps>(function AuroraCanvas(
  { intensity = 'default', className, children, ...rest },
  ref,
) {
  return (
    <div ref={ref} aria-hidden="true" className={cn('g-aurora', className)} {...rest}>
      {/*
        Dimming is a canvas-coloured scrim rather than an opacity on the whole
        layer: `.g-aurora` also paints the page background, and fading that
        would let the document body show through instead of muting the mesh.
      */}
      {intensity === 'subtle' ? (
        <div
          className="absolute inset-0"
          style={{ background: 'var(--g-canvas)', opacity: 0.45 }}
        />
      ) : null}
      {children}
    </div>
  );
});
